import { Component, Input, OnChanges } from '@angular/core';


@Component({
  selector: 'app-import-error-file',
  templateUrl: './import-error-file.component.html',
  styleUrls: ['./import-error-file.component.css'],
  standalone: false
})

export class ImportErrorFileComponent implements OnChanges {
  columns: string[] = [];
  rows: any[] = [];
  headerErrors: string[] = [];

  @Input()
  title: string;

  @Input()
  data: any;

  ngOnChanges() {
    this.headerErrors = [];
    this.columns = [];
    this.rows = [];

    if (!this.data || this.data.length === 0) return;

    // Header-level error: Row is null, only Errors present
    const first = this.data[0];
    if (first.Row === null || first.Row === undefined) {
      const errors: any[] = Array.isArray(first.Errors) ? first.Errors : (first.Errors?.$values ?? []);
      this.headerErrors = errors.map((e: any) => e.message);
      return;
    }

    this.buildCleanRows();
    this.extractColumns();
  }

  extractColumns(): void {
    const firstRow = this.data.find((d: any) => d.Row != null)?.Row;
    if (!firstRow) return;
    this.columns = Object.keys(firstRow);
  }

  buildCleanRows(): void {
    this.rows = this.data.filter((item: any) => item.Row != null).map((item: any) => item.Row);
  }

  /** Reads columnName from either casing: FileColumnError (lowercase c) or AzureFileColumnError (uppercase C) */
  private getErrorColumnName(e: any): string {
    return e.columnName ?? e.ColumnName ?? '';
  }

  /** Reads message from either casing */
  private getErrorMessage(e: any): string {
    return e.message ?? e.Message ?? '';
  }

  isColumnError(row: any, columnName: string): boolean {
    if (!row?.Errors || row.Errors.length === 0) return false;
    return row.Errors.some((e: any) => this.getErrorColumnName(e) === columnName);
  }

  getFormattedErrors(row: any): string {
    if (!row?.Errors || row.Errors.length === 0) return '';
    return row.Errors
      .map((e: any, index: number) => `${index + 1}- ${this.getErrorColumnName(e)} : ${this.getErrorMessage(e)}`)
      .join('<br>');
  }

}





